<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section" style="padding-bottom: 0px !important;">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">My Wallet</h2>
              <!-- <h2 class="listing-page-desc">Fill Details</h2> -->
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid ib-acquisition-bg" v-if="WalletInfo.is_wallet == 1">
      <div class="container ib-p-0">
        <div class="container multistep-box">
          <!-- flower for box -->
          <!-- <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" /> -->
          <!-- flower for box -->

<!-- <div class="container multistep-box"> -->
              <!--Added by umar farooq-->
          <div class="row detail-header ib-align-start">
              <div class="col-md-6 col-lg-4 col-xl-3">
                <div class="detail-header-img">
                  <div>
                    <img class="img-fluid" :src="require('@/assets/images/Group 84458.svg')" alt="icon">
                    <img class="img-fluid" src="" alt="icon">
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 col-xl-3 pl-lg-0">
                <h3 class="header-title wallet_header">My Wallet</h3>
                <div class=""  style="display: flex">
                  <p class="header-td-first wallet_value">{{ WalletInfo.amount }}</p>
                  <small class="wallet_pkr">{{ WalletInfo.currency }}</small>
                </div>
              </div>
                <div class="col-md-6 pl-0">
                     <div class="status-in-process text-capitalize mb-3 wallet_level">Level 0</div>
                    <div class="d2c-class-container mb-3 px-2 in-pt-77" style="padding-top:55px !important">
                          <!-- Nav tabs -->
                        <ul class="nav nav-tabs ib-nav-tabs mx-auto ml-md-0 wallet_tabs" role="tablist">
                            <li class="nav-item">
                              <a class="nav-link class-box">
                                <img  :src="require('@/assets/images/Artboard – 7.svg')" alt="icon">
                                <h4 class="class-name class-buy">top-up</h4>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link class-box">
                                <img  :src="require('@/assets/images/Artboard – 8.svg')" alt="icon">
                                <h4 class="class-name class-buy">Transfer</h4>
                              </a>
                            </li>
                             <li class="nav-item">
                              <a class="nav-link class-box">
                                <img  :src="require('@/assets/images/Artboard – 9.svg')" alt="icon">
                                <h4 class="class-name class-buy">Order Card</h4>
                              </a>
                            </li>
                             <li class="nav-item">
                              <a class="nav-link class-box">
                                <img  :src="require('@/assets/images/Artboard – 10.svg')" alt="icon">
                                <h4 class="class-name class-buy">Upgrade account</h4>
                              </a>
                            </li>
                          </ul>
                     </div>
                  </div>
        </div>
        <div class="row">
        <div class="col-md-12">
                            <div class="listing-nav">
                              <div class="d2c-main-classes">
                                <button class="d2c-class-btn" >
                                  <div class="in-right-border" style="text-transform: capitalize;">
                                    Top-up Amount
                                  </div>
                                </button>
                                <button class="d2c-class-btn" >
                                  <div class="in-right-border" style="text-transform: capitalize;">
                                    Fund Transfer
                                  </div>
                                </button>
                                <button class="d2c-class-btn" >
                                  <div class="in-right-border" style="text-transform: capitalize;">
                                    Fund Received
                                  </div>
                                </button>
                                <button class="d2c-class-btn" >
                                  <div class="in-right-border" style="text-transform: capitalize;">
                                    Spent Amount
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
        </div>
        <div class="row">
          <div class="col-md-12 d-none d-md-block">
                          <table class="claim-listing wallet_table">
                            <tbody>
                            <tr>
                               <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Amount Top-up</div>
                                  <div class="jbl-date-td">Added to your wallet Balance</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Date</div>
                                  <div class="jbl-date-td">08-Feb-2022</div>
                                </div>
                              </td>
                             <td class="jbl-responsive-td">
                                <div class="jbl-flex-td pkr_velu">
                                  <span class="positive">2,000</span><span> &nbsp; PKR</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                               <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Amount Top-up</div>
                                  <div class="jbl-date-td">Added to your wallet Balance</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Date</div>
                                  <div class="jbl-date-td">08-Feb-2022</div>
                                </div>
                              </td>
                             <td class="jbl-responsive-td">
                                <div class="jbl-flex-td pkr_velu">
                                  <span class="negative">-3,000</span><span> &nbsp; PKR</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                               <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Amount Top-up</div>
                                  <div class="jbl-date-td">Added to your wallet Balance</div>
                                </div>
                              </td>
                              <td class="jbl-responsive-td">
                                <div class="jbl-flex-td">
                                  <div class="jbl-date-td jbl-date-heading">Date</div>
                                  <div class="jbl-date-td">08-Feb-2022</div>
                                </div>
                              </td>
                             <td class="jbl-responsive-td">
                                <div class="jbl-flex-td pkr_velu">
                                  <span class="positive">2,000</span><span> &nbsp; PKR</span>
                                </div>
                              </td>
                            </tr>

                            </tbody>
                          </table>
                        </div>
        </div>
              <!----------------------->
           
            
            <!-- </div> -->

        </div>
      </div>
    </div>
<!-- ///////////////////////////////////////////////// -->

<!-- ///////////////////////////////////////////////// -->
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import MaskedInput from "vue-masked-input";
  import axios from 'axios';

  export default {
    name: "ViewWallet",
    data () {
      return {
        showLoader: false,
        user: {},
        WalletInfo: {},
        errors : [],
        cnic:'',
        cnic_issuance_date:'',
        mobile_no:'',
        mobile_network:'',
      };
    },
    components: {
      loading,
    },
    created () {
      const self = this;
      self.user = self.$store.getters.getUser;
      self.getWalletInfo();
    },
    methods:{
      async getWalletInfo() {
      const self = this;
      self.errors = [];

      self.showLoader = true;
      await axios.post('customer/balance_inquiry').then(async function (resp) {
        if(resp.data.data.is_wallet == 1){
          if (resp.data.code == 200) {
            self.WalletInfo = resp.data.data;
            self.showLoader = false;
            // console.log('WalletInfo',self.WalletInfo);
          } else {
            self.showLoader = false;
            $toast.error('Wallet info error '+resp.data.message, {position: 'top-right'});
            return false;
          }
        }else{
          self.showLoader = false;

          self.$swal.fire({
          text: "You Don't Have Wallet Account, Please Create Your Wallet First!",
          icon: '',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'LATER',
          confirmButtonColor: '#f77c94',
          confirmButtonText: 'CREATE NOW'
          }).then((result) => {
            if (result.isConfirmed) {
              self.$router.push({ name: 'CreateWallet' });
            }else{
              self.$router.push({ name: 'Home' });
            }
          });
        }
      }).catch(function (error) {
        self.showLoader = false;
        if (error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, {position: 'top-right'});
          });
        } else {
          $toast.error(error.data.message, {position: 'top-right'});
        }
      });
    },

    }
  };
</script>
<style scoped>
  /* ul {
    list-style: none;
  }
  li {
    position: relative;
    color:  var(--text-color);
    font-family: "Avenir Book";
  }
  li:before {
    content: "•";
    position: absolute;
    left: -1em;
    color: var(--secondary-color);
  }
  .custom-number li:before {
    content: "";
    position: absolute;
    left: -1em;
  }
  .article-box p{
    font-family: "Avenir Book";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: var(--text-color);
  } */
.panel-default{
    /* background-color: rgba(249, 252, 253, 0.7); */
    margin-bottom: 18px;
  }
  .panel-body{
    font-family: "Avenir Book";
    font-size: 14px;
    text-align: left;
    color: #787b7c;
    padding: 15px;
  }
  .collapsible-link a{
    margin: 0 0 10px !important;
}
.legal-box-title{
  margin: 10px 0px;
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #ef7c94;
}
.legal-box-title span {
  color: #3d9cbd;
}

/* group rows CSS */
 .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 9px 0;
    padding: 10px;
    border-radius: 10px;
    border: solid 1px rgba(55, 141, 171, 0.25);
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
  }
  .position-relative .small-icon{
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 14px;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 84px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 0 0px 1px #d8eaf1;
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
    text-transform: capitalize;
  }
  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family: "Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  /* .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  } */
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  /* group rows CSS end here */
  .d2c-main-classes {
  background-color: #def3f7;
  border-radius: 31px;
  max-width: fit-content;
  margin: 1px 0 30px;
}
.d2c-class-btn {
  display: inline-block;
  margin-bottom: 0;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 61px;
  margin: 0 0 1px;
  border-radius: 31px;
  background-color: #def3f7;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.38;
  color: #4c505d;
  transition: all .3s ease-in;
}
.d2c-class-btn:hover {
  background-color: #049cbd;
  color: white;
}
.d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
  outline: none !important;
  background-color: #049cbd;
  color: white;
}
/* .d2c-main-classes .d2c-class-btn::after {
  content: '';
  width: 0;
  height: 35px;
  border: solid 1px #049ab3;
  position: relative;
  right: -16px;
}
.d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
  content: '';
  border: none !important;
}
.d2c-main-classes button:last-child.d2c-class-btn::after {
  content: '';
  border: none !important;
} */
.nex-Page-Link .fa-chevron-right {
  color: #aeccd6 !important;
  font-weight: normal !important;
}
@media(max-width:550px){
  .d2c-class-btn{
    padding: 6px 22px !important;
    width: max-content !important;
    font-size: 12px !important;
  }
}
.multistep-box label:not(.css-label,.css-label-checked) {
  display: block !important;
  text-align: left !important;
}
table.claim-listing {
  width: 100%;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-collapse: separate;
  border-spacing: 0 10px;
}
table.claim-listing td {
  height: 100px !important;
  vertical-align: middle;
  text-align: center;
  position: relative;
}
@media (max-width:668px) {
  table.claim-listing td:not(:first-child) {
    height: 60px !important;
  }
  table.claim-listing tbody td:first-child {
    height: auto !important;
  }
}
table.claim-listing td:last-child:after {
  content: none;
}
table.claim-listing tbody td {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
@media (min-width:669px) {
  table.claim-listing tbody td:first-child {
    border-left: 1px solid #eee;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  table.claim-listing tbody td:last-child {
    border-right: 1px solid #eee;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  table.claim-listing tbody tr {
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  }
}
.pkr_velu{
    display: flex;
    flex-direction: row;
    justify-content: end;
    padding-right: 20px;
}
table.wallet_table{
 margin-bottom: 15px !important;
}
table.wallet_table > tbody > tr > td{
  height: 85% !important;
  padding: 15px;
}
table.wallet_table > tbody > tr{
   box-shadow: 0 0 0px 1px #d8eaf1 !important;
}
table.wallet_table > tbody > tr > td:nth-child(1){
  padding-left: 20px;
  width: 45% !important;
}
table.wallet_table > tbody > tr > td:last-child > div > span.negative{
 color: var(--secondary-color) !important;
}
table.wallet_table > tbody > tr > td:last-child > div > span.positive{
 color:  #0db73b !important;
}
.wallet_level{
    position: absolute;
    top: 10%;
    right: 5%;
    width: 7.4375rem !important;
    height: 2.1rem !important;
    font-size: 14px !important;
}
ul.wallet_tabs{
     margin-left: 5.6rem !important;
}
@media (max-width:1200px) {
ul.wallet_tabs{
  margin-left: 0px !important;
}
}
ul.wallet_tabs > li.nav-item > a.nav-link.class-box{
  width: 5.5rem !important;
  height: 5.5rem !important;
  margin: 0.3rem !important;
  box-shadow: 0px 0px 0px 2px rgb(239 124 148 / 10%) !important;
}
ul.wallet_tabs > li.nav-item > a.nav-link.class-box > img{
  margin-bottom: 0px !important;
}
ul.wallet_tabs > li.nav-item > a.nav-link.class-box > h4{
  font-size: 0.8rem !important;
  color: #3d9cbd !important;
}
ul.wallet_tabs > li.nav-item:last-child > a.nav-link.class-box > h4{
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Wallet/MyWallet.vue